import { z } from 'zod'

import { ConversationEndReason } from 'apps/aiAutomation/store/instantAnswersPlayground/types'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const InstantAnswersPlaygroundSocketEventsSchemas = {
  messageGenerated: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_message_generated'),
    message: z.object({
      text: z.string(),
    }),
    session_id: z.string(),
  }),

  sessionFinished: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_session_finished'),
    session_id: z.string(),
    reason: z.union([
      z.literal(ConversationEndReason.SUCCESS),
      z.literal(ConversationEndReason.OPERATOR_REQUESTED),
    ]),
  }),

  scenarioNotRecognized: SocketEventBaseSchema.extend({
    event: z.literal('ai_automation_scenario_not_recognized'),
    session_id: z.string(),
  }),
}
